export default () => ({
  trigger: {
    name: 'chatbot.click_send_feedback',
    params: {},
  },
  config: {
    event: {
      name: 'confirm',
      params: {
        sub_feature: 'message',
        status: 'success',
      },
    },
  },
});
